import script from "./text-field.vue?vue&type=script&setup=true&lang=ts"
export * from "./text-field.vue?vue&type=script&setup=true&lang=ts"

import "./text-field.vue?vue&type=style&index=0&id=6235dfa9&scoped=true&lang=scss"

import exportComponent from "/builds/snedson/snotra-backend/snotra-front-ts/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6235dfa9"]])

export default __exports__